import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/common/alert.service';
import { LoginService } from '../login/login.service';
import { first } from 'rxjs';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';
import { RetailStoreService } from 'src/app/services/retail-store.service';
import { BusinessUserService } from 'src/app/services/business-user.service';

@Component({
  selector: 'app-approve-user',
  templateUrl: './approve-user.component.html',
  styleUrls: ['./approve-user.component.scss']
})
export class ApproveUserComponent implements OnInit {
  queryString = Object();
  model: any;

  businessModel: any;
  storeModel: any;

  constructor(private alertService: AlertService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private retailStoreService: RetailStoreService,
    private businessUserService: BusinessUserService,
    private storageService: StorageService,
    private loginService: LoginService,) { }

  ngOnInit() {
    this.queryString = this.activatedRoute.snapshot.queryParams;
    if (this.queryString?.approveToken) {
      var approveToken = this.queryString?.approveToken;
      var decrypt = window.atob(approveToken)
      this.model = JSON.parse(decrypt);
      this.storageService.setValue(StorageKey.authToken, this.model.adminToken);
    }
    else {
      this.alertService.showError("Invalid link");
      this.router.navigate(['login']);
    }

    this.retailStoreService.detail(this.model.storeId).subscribe((response: any) => {
      if (response.success) {
        this.storeModel = response.data;
      }
    })

    this.businessUserService.detail(this.model.businessId).subscribe((response: any) => {
      if (response.success) {
        this.businessModel = response.data;
      }
    })
  }

  onClickConfirm() {
    this.loginService.bussiness_approve(this.model.id ?? this.model._id).pipe(first()).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.storageService.removeValue(StorageKey.authToken);
          this.router.navigate(['login']);
        }
      }
    });
  }
}
